import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Link, Tooltip, Typography } from '@mui/material'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import dayjs from 'dayjs'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { TASK_TYPE } from '../../common/constants'
import FileViewWidget from '../file/FileView'
import { Stack } from '@mui/system'
import { UnreadPaidServiceBtn } from '../../modules/PaidServiceUnread/ui/UnreadPaidServiceBtn'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

type MainTableProps = {
  mainTable?: any
}

export default function MainTable({ mainTable }: MainTableProps) {
  const rows = mainTable?.data?.rows
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ border: '1px solid #e6e6e6', boxShadow: 0 }}
      >
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableRow-root:hover .paid-service-mark-unread-button': {
              opacity: 1,
              visibility: 'visible',
              transitionDelay: '0.5s'
            }
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                №
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Дата регистрации
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Контрагенты
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Авария
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Бюджетн.
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Калькуляция
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Счет
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Акт
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                УПД
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Договор оригнал
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Ответственныe
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.length > 0 &&
              rows?.map((row: any) => (
                <StyledTableRow key={row.documentInfo}>
                  <TableCell align="center">
                    <Stack
                      direction="row"
                      gap={1}
                      alignItems="center"
                      justifyContent="center"
                    >
                      {!row.isViewed ? (
                        <Tooltip title="Услуга не прочитана">
                          <FiberManualRecordIcon
                            color="primary"
                            sx={{ fontSize: '10px' }}
                          />
                        </Tooltip>
                      ) : (
                        <UnreadPaidServiceBtn paidServiceId={row.id} />
                      )}
                      <Link href={`/service-page/${row.id}`}>
                        {row.documentInfo}
                      </Link>
                    </Stack>
                  </TableCell>
                  <TableCell align="center">{row.createdAt}</TableCell>
                  <TableCell align="center">
                    {row.clientNames?.map((elem: string) => elem)}
                  </TableCell>
                  <TableCell align="center">
                    {row.isEmergency ? 'Да' : 'Нет'}
                  </TableCell>
                  <TableCell align="center">
                    {row.isMunicipal ? 'Да' : 'Нет'}
                  </TableCell>
                  <TableCell align="center">
                    {row.needsCalculation ? 'Да' : 'Нет'}
                  </TableCell>
                  <TableCell align="center">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {row.bills?.initial?.billNumber && (
                        <>
                          {`№${row.bills?.initial?.billNumber} от ${dayjs(
                            row.bills?.initial?.billDate
                          ).format('DD.MM.YYYY')}`}{' '}
                          {row.bills?.initialStatus}
                        </>
                      )}
                      <br />
                      {row.bills?.additional?.needsAdditionalBill &&
                        row.bills?.additional?.additionalBillNumber && (
                          <>
                            {`№${
                              row.bills?.additional?.additionalBillNumber
                            } от ${dayjs(
                              row.bills?.additional?.additionalBillDate
                            ).format('DD.MM.YYYY')}`}{' '}
                            {row.bills?.additionalStatus}
                          </>
                        )}
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <FileViewWidget
                      files={row.files[TASK_TYPE.EXECUTION] || []}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <FileViewWidget
                      files={row.files[TASK_TYPE.ADDITIONAL_BILLING] || []}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <FileViewWidget
                      files={
                        row.files[TASK_TYPE.CONTRACT_PAYMENT_CONFIRMATION] || []
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="column">
                      {row.responsibleUserNames.map((name: string) => (
                        <Typography variant="caption">{name}</Typography>
                      ))}
                    </Stack>
                  </TableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
